import {
    SEARCH_CMS,
    SEARCH_CMS_ERROR,
} from "../actions/types";

const initialState = {
    cmsSearchResults: {},
    isLoading: true,
    success: false,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SEARCH_CMS:
            return {
                ...state,
                cmsSearchResults: payload,
                isLoading: false,
                success: true,
            };
        case SEARCH_CMS_ERROR:
            return {
                ...state,
                cmsSearchResults: {},
                isLoading: false,
                success: false,
            };
        default:
            return state;
    }
}
